import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Box, Tabs, Tab } from '@mui/material';
import WidgetBox from '../../../../Components/Paper/WidgetBox';

const DataDetailsBox = function DataDetailsBox({ data }) {
  const intl = useIntl();
  const [tabValue, setTabValue] = useState('');
  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (nSteps) => {
    setCurrentPage((oldStep) => oldStep + nSteps);
  };

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (data) {
      setTabValue(Object.keys(data)[0]);
    }
  }, [data]);

  useEffect(() => {
    setCurrentPage(0);
  }, [tabValue]);

  const WidgetComponent = data[tabValue]?.Widget;
  return Object.keys(data).length === 0 ? null : (
    <WidgetBox
      pages={data[tabValue]?.data.length}
      currentPage={currentPage}
      handleChangePage={handleChangePage}
      height="40%"
      widget={
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%"
          }}>
          {Object.keys(data).length > 1 && (
            <Tabs
              value={tabValue}
              onChange={handleChangeTab}
              variant="fullWidth"
              style={{ height: '36px' }}
            >
              {Object.keys(data).map((label, index) => (
                <Tab
                  key={`${String(index)}`}
                  label={intl.messages[label] || label}
                  value={label}
                />
              ))}
            </Tabs>
          )}
          {tabValue && (
            <WidgetComponent data={data[tabValue]?.data[currentPage]} />
          )}
        </Box>
      }
    />
  );
};

DataDetailsBox.propTypes = {
  data: PropTypes.object,
};

export default DataDetailsBox;
